/**
 * Download Cards Load More functionality
 */
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.download-cards-container');

  containers.forEach((container) => {
    const initialVisible = parseInt(container.dataset.initialVisible) || 6;
    const cards = container.querySelectorAll('.download-card');
    const blockId = container.closest('[data-block-id]')?.dataset.blockId;
    const loadMoreButton = document.querySelector(
      `.load-more-button[data-target="${blockId}"]`,
    );

    // Hide cards beyond initial visible count
    cards.forEach((card, index) => {
      if (index >= initialVisible) {
        (card as HTMLElement).style.display = 'none';
      }
    });

    // Load more functionality
    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', () => {
        cards.forEach((card) => {
          (card as HTMLElement).style.display = 'flex';
        });
        (loadMoreButton as HTMLElement).style.display = 'none';
      });
    }
  });
});
